import {
  Button,
  H1,
  Image,
  Paragraph,
  YStack,
} from '@bounty/creators-design-system'
import { Linking } from 'react-native'

const NEW_PLATFORM_URL = 'https://www.creatoropportunity.com'
const PARTNRUP_LOGO_URL = '/partnrup-logo-dark-round.svg'

export const MigrationLanding = () => {
  return (
    <YStack
      backgroundColor="rgba(92, 225, 230, 1)"
      data-testid="migration-landing-page"
      flex={1}
      minHeight="100vh"
      pb="$10"
      pt="$8"
      px="$4"
    >
      <YStack alignSelf="center" maxWidth={640} width="100%">
        <Image
          alt="partnrUP logo"
          height={96}
          marginBottom="$5"
          resizeMode="contain"
          source={{ uri: PARTNRUP_LOGO_URL }}
          width={240}
        />
        <H1 color="rgb(56, 56, 57)" mb="$4" size="$2xl">
          Bounty is now partnrUP
        </H1>
        <Paragraph color="rgb(56, 56, 57)" mb="$6" size="$md">
          This site is no longer available. Visit Creator Opportunity by
          partnrUP to see what new brand partnerships and earning opportunities
          we might have for you.
        </Paragraph>
        <Button
          alignSelf="flex-start"
          onPress={() => Linking.openURL(NEW_PLATFORM_URL)}
        >
          Go to Creator Opportunity
        </Button>
      </YStack>
    </YStack>
  )
}
